import React from "react";

export default function UpdateAlert() {
  return <></>;
}
